import { useState } from "react";
import { galleryImages } from "@/mocks/gallery";

const categoryFilters = ["全部", "ai美女写真", "ai美女头像", "ai美女壁纸", "ai虚拟美女"];

export default function Gallery() {
  const [activeFilter, setActiveFilter] = useState("全部");

  const filtered =
    activeFilter === "全部"
      ? galleryImages
      : galleryImages.filter((img) => img.category === activeFilter);

  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-4">
            作品展示
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-4">
            AI美女作品画廊
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            精选高质量AI生成美女作品，每一张都是AI艺术与美学的完美结合。
          </p>
        </div>

        <div className="flex items-center justify-center gap-2 mb-10 flex-wrap">
          {categoryFilters.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveFilter(cat)}
              className={`px-5 py-2 text-sm rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer ${
                activeFilter === cat
                  ? "bg-primary-500 text-white font-medium"
                  : "bg-background-50 text-foreground-600 hover:text-foreground-950 hover:bg-background-200 border border-background-200/70"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {filtered.map((image) => (
            <div
              key={image.id}
              className="group relative rounded-xl overflow-hidden bg-background-200 cursor-pointer"
              data-product-shop
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={image.imageUrl}
                  alt={image.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                <div>
                  <h3 className="text-sm font-medium text-white mb-1">
                    {image.title}
                  </h3>
                  <div className="flex items-center gap-1.5 flex-wrap">
                    {image.tags.map((tag) => (
                      <span
                        key={tag}
                        className="text-xs px-2 py-0.5 rounded-full bg-white/20 text-white/90"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="px-6 py-2.5 text-sm text-primary-600 border border-primary-300 rounded-full hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            加载更多作品
          </button>
        </div>
      </div>
    </section>
  );
}